import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../entities';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import type { ThirdPartyConfig } from '../../schemas/3p-config';

import { DovetailIcon } from './icon';
import { DovetailSearchResultIcon } from './search-result-icon';

export const dovetailConfig: ThirdPartyConfig = {
	displayName: 'Dovetail',
	id: 'dovetail',
	resourceType: 'smartlinks-connector-dovetail',
	icon: get3PLogo(DovetailIcon, 'Dovetail', 'medium'),
	searchResultIcon: get3PLogo(DovetailSearchResultIcon, 'Dovetail', 'large'),
	integrationAri: 'ari:cloud:platform::integration/dovetail',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
